export default {
    INIT: "INIT_LOGIN",
    SET: "SET",
    LOGIN: "LOGIN",
    LOGOUT: "LOGOUT"
};
